"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixPhone = void 0;
exports.fixPhone = (phone) => {
    if (phone && phone.slice(4, 5) === "8") {
        return phone.slice(0, 4) + phone.slice(5);
    }
    return phone;
};
//# sourceMappingURL=fixPhone.js.map